import React from 'react';
import Masonry from 'react-masonry-css';
import { Photo } from '../types';

interface PhotoGridProps {
  photos: Photo[];
}

const PhotoGrid: React.FC<PhotoGridProps> = ({ photos }) => {
  // 响应式断点配置
  const breakpointColumnsObj = {
    default: 4,  // 默认4列
    1100: 3,     // 屏幕宽度 <= 1100px 时显示3列
    700: 2,      // 屏幕宽度 <= 700px 时显示2列
    500: 2       // 屏幕宽度 <= 500px 时显示2列
  };

  if (photos.length === 0) {
    return (
      <div className="text-center py-16 sm:py-32 px-4">
        <div className="max-w-sm mx-auto bg-white rounded-3xl p-8 sm:p-12 shadow-sm border border-stone-200/60">
          <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-6 sm:mb-8 bg-stone-800 rounded-full flex items-center justify-center shadow-lg">
            <span className="text-2xl sm:text-3xl">📸</span>
          </div>
          <h3 className="text-xl sm:text-2xl font-serif text-stone-800 mb-3 sm:mb-4">暂无照片</h3>
          <p className="text-stone-500 text-base sm:text-lg">管理员还没有上传照片，敬请期待精彩瞬间</p>
        </div>
      </div>
    );
  }

  return (
    <div className="px-3 sm:px-4 lg:px-8 pb-32">
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="masonry-grid"
        columnClassName="masonry-grid_column"
      >
        {photos.map((photo) => (
          <div 
            key={photo.id} 
            className="mb-3 sm:mb-4 group cursor-pointer"
          >
            <div className="relative overflow-hidden rounded-lg sm:rounded-xl shadow-sm hover:shadow-lg transition-all duration-300">
              <img
                src={photo.url}
                alt={photo.caption}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              
              {/* 轻微的悬浮效果 */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-all duration-300" />
            </div>
          </div>
        ))}
      </Masonry>
    </div>
  );
};

export default PhotoGrid;